import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
export function FloatingCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex flex-col items-center gap-2 transition-transform duration-500 ease-[cubic-bezier(0.175,0.885,0.32,1.275)] ${isVisible ? 'translate-y-0' : 'translate-y-[150px]'}`} data-id="element-24">
      <a href="https://pay.hotmart.com/S104868471X" target="_blank" rel="noopener noreferrer" className="btn-sweep inline-flex items-center justify-center gap-2 bg-gradient-to-r from-accent via-accent-light to-accent-dark text-primary text-sm md:text-base font-extrabold py-3.5 px-7 md:py-4 md:px-9 rounded-full border-none cursor-pointer no-underline shadow-[0_8px_24px_rgba(232,160,32,0.35)] whitespace-nowrap hover:scale-105 transition-transform" data-id="element-25">
        <Zap className="w-4 h-4 md:w-5 md:h-5" data-id="element-26" />
        <span className="hidden md:inline" data-id="element-27">
          ¡Quiero apagar el fuego del reflujo! — 12 USD
        </span>
        <span className="md:hidden" data-id="element-28">¡Acceder ahora! — 12 USD</span>
      </a>
      <span className="bg-primary/90 border border-accent/20 text-text-muted text-[11px] md:text-xs py-1 px-3 rounded-full backdrop-blur-md" data-id="element-29">
        <span className="hidden md:inline" data-id="element-30">
          Precio normal 120 USD — Garantía 7 días
        </span>
        <span className="md:hidden" data-id="element-31">Garantía 7 días</span>
      </span>
    </div>;
}